import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Your record is ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: _ctx.$style.container,
    ref: "divRef"
  }, [
    _createVNode("canvas", {
      ref: "canvasRef",
      class: _ctx.$style.canvas
    }, null, 2),
    (_ctx.isGameOver)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: _ctx.$style.gameover
        }, [
          _createVNode("div", {
            class: _ctx.$style.text
          }, [
            _createVNode("div", {
              class: _ctx.$style.gameover_text
            }, "Game Over", 2)
          ], 2),
          _createVNode("div", {
            class: _ctx.$style.text
          }, [
            _createVNode("div", {
              class: _ctx.$style.score_text
            }, [
              _hoisted_1,
              _createVNode("span", {
                class: _ctx.$style.score
              }, _toDisplayString(_ctx.score), 3)
            ], 2)
          ], 2),
          _createVNode("div", {
            class: _ctx.$style.text
          }, [
            _createVNode("div", {
              class: _ctx.$style.replay_text,
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.restart(...args)))
            }, "replay", 2)
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}